import {
  DocumentFraudAnalysisSettingsModel,
  FraudAnalysisVendorEnum,
} from '../../../../../shared/models';
import yup from '../../../../../utils/yup-extended';
import { defaultFraudAnalysisSettings } from '../default-fraud-analysis-settings';

export const fraudAnalysisSettingsSchema =
  (): yup.SchemaOf<DocumentFraudAnalysisSettingsModel> => {
    return yup
      .object()
      .shape({
        vendor: yup
          .mixed()
          .oneOf(Object.values(FraudAnalysisVendorEnum))
          .optional()
          .default(defaultFraudAnalysisSettings.vendor),
      })
      .noUnknown()
      .nullable()
      .default(defaultFraudAnalysisSettings);
  };
